var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticClass:"pa-0",attrs:{"disabled":_vm.disabled,"value":_vm.value,"loading":_vm.grade.grade.fetching,"items":_vm.gradeItems,"outlined":"","dense":"","multiple":_vm.multiple,"label":_vm.label || 'Select grade'},on:{"change":_vm.setGrade}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }